import { render, staticRenderFns } from "./TiktokOEmbed.vue?vue&type=template&id=1aa778ac&scoped=true&"
import script from "./TiktokOEmbed.vue?vue&type=script&lang=js&"
export * from "./TiktokOEmbed.vue?vue&type=script&lang=js&"
import style0 from "./TiktokOEmbed.vue?vue&type=style&index=0&id=1aa778ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa778ac",
  null
  
)

export default component.exports